import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Message = {
  from: 'user' | 'bot'
  text: string
  shouldAnimate?: boolean
}

type ChatBotStore = {
  messages: Message[]
  addMessage: (msg: Message) => void
  clearMessages: () => void
}

export const useChatBotStore = create<ChatBotStore>()(
  persist(
    set => ({
      messages: [],
      addMessage: msg =>
        set(state => {
          const updatedMessages =
            msg.from === 'bot'
              ? [...state.messages, { ...msg, shouldAnimate: true }]
              : [...state.messages, msg]
          return { messages: updatedMessages }
        }),
      clearMessages: () => set({ messages: [] })
    }),
    {
      name: 'chat-storage'
    }
  )
)
